<template>
  <section style="background: linear-gradient(to top, #dfe9f3 0%, white 100%)">
    <div>
      <h4
        style="
          font-size: 30px;
          font-family: 'Poppins', sans-serif;
          padding: 0px;
        "
      >
        Contact
        <span style="color: #42b983">Me</span>
      </h4>
      <form
        name="contactos"
        method="post"
        data-netlify="true"
        data-netlify-honeypot="bot-field"
      >
        <input type="hidden" name="form-name" value="contactos" />
        <input
          name="name"
          type="text"
          class="feedback-input subheading"
          placeholder="Name"
        />
        <input
          name="email"
          type="email"
          class="feedback-input subheading"
          placeholder="Email"
        />
        <textarea
          name="text"
          class="feedback-input subheading"
          placeholder="Message"
        ></textarea>
        <button type="submit">LET'S TALK</button>
      </form>
    </div>
  </section>
</template>

<style scoped>
@import url(https://fonts.googleapis.com/css?family=Montserrat:400,700);

form {
  max-width: 420px;
  margin: 50px auto;
  padding-bottom: 200px;
}

.feedback-input {
  color: rgb(0, 0, 0);
  font-weight: 500;
  font-size: 18px;
  border-radius: 5px;
  line-height: 22px;
  background-color: transparent;
  border: 2px solid #42b983;
  transition: all 0.3s;
  padding: 13px;
  margin-bottom: 15px;
  width: 100%;
  box-sizing: border-box;
  outline: 0;
}

.feedback-input:focus {
  border: 2px solid #42b983;
}

textarea {
  height: 150px;
  line-height: 150%;
  resize: vertical;
}

[type="submit"] {
  font-family: "Poppins", sans-serif;
  letter-spacing: 3px;
  width: 100%;
  background: #42b983;
  border-radius: 5px;
  border: 0;
  cursor: pointer;
  color: white;
  font-size: 24px;
  padding-top: 10px;
  padding-bottom: 10px;
  transition: all 0.3s;
  margin-top: -4px;
  font-weight: 700;
}
[type="submit"]:hover {
  background: rgb(52 144 103 / 90%);
}
</style>
